import { useQuery, useMutation, keepPreviousData } from "@tanstack/react-query";
import qs from "qs";
import api from "@services/api";

async function fetchLandingPages(filters, page, pageSize) {
  const query = qs.stringify(
    { ...filters, page, page_size: pageSize },
    { arrayFormat: "indices", encodeValuesOnly: true }
  );
  const { data } = await api.get(`/landing-page?${query}`);
  return data;
}

export function useLandingPagesQuery(filters, page, pageSize) {
  return useQuery({
    queryKey: ["catalog", "landing-page", filters, page, pageSize],
    queryFn: () => fetchLandingPages(filters, page, pageSize),
    placeholderData: keepPreviousData
  });
}

export function useLandingPageQuery(id) {
  return useQuery({
    queryKey: ["catalog", "landing-page", id],
    queryFn: async () => {
      const { data } = await api.get(`/landing-page/${id}`);
      return data;
    },
    enabled: !!id
  });
}

export function useCreateLandingPageMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post(`/landing-page`, payload);
      return data;
    }
  });
}

export function useSaveLandingPageMutation() {
  return useMutation({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.put(`/landing-page/${id}`, payload);
      return data;
    }
  });
}

export function useDeleteLandingPageMutation() {
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete(`/landing-page/${id}`);
      return data;
    }
  });
}

